module.exports = __webpack_public_path__ + "img/banner4.e0fd2eca.jpg";